import { PayloadAction } from '@reduxjs/toolkit';
import { produce } from 'immer';

import { SubscriptionState } from './subscriptions.types';

export const setSubscriptionsReducer = (
  state: SubscriptionState,
  action: PayloadAction<{ subscription: Partial<SubscriptionState> }>
) =>
  produce(state, (draft) => {
    const { nextRenewalDate, isActive } = action.payload.subscription;

    if (nextRenewalDate !== undefined) {
      draft.nextRenewalDate = nextRenewalDate;
    }

    if (isActive !== undefined) {
      draft.isActive = isActive;
    }
  });
